export const UPLOAD_RETENTION_MS = 7 * 24 * 60 * 60 * 1000
